import { Command } from 'commander'
import { registerAccount } from './commands/account.js'
import { registerApi } from './commands/api.js'
import { registerApiKey } from './commands/apikey.js'
import { registerDev } from './commands/dev.js'
import { registerExec } from './commands/exec.js'
import { registerFiles } from './commands/files.js'
import { registerInit } from './commands/init.js'
import { registerKeygen } from './commands/keygen.js'
import { registerLogin } from './commands/login.js'
import { registerPack } from './commands/pack.js'
import { registerPackage } from './commands/package.js'
import { registerPublisher } from './commands/publisher.js'
import { registerRegistry } from './commands/registry.js'
import { registerSettings } from './commands/settings.js'
import { registerUpdate } from './commands/update.js'
import { registerUse } from './commands/use.js'
import { registerUser } from './commands/user.js'
import { registerValidate } from './commands/validate.js'
import { registerWorkspace } from './commands/workspace.js'
import { ApiError } from './http.js'
import { notifyOnExit } from './update/notifier.js'
import { getCliVersion } from './version.js'

const program = new Command()
  .name('verentis')
  .description('Verentis CLI — admin, marketplace publishing, and the engine/app developer loop')
  .version(getCliVersion())

// Auth + context
registerLogin(program)
registerUse(program)

// Admin
registerAccount(program)
registerWorkspace(program)
registerUser(program)
registerApiKey(program)
registerSettings(program)

// Workspace files + executions
registerFiles(program)
registerExec(program)

// Developer loop
registerDev(program)
registerValidate(program)

// Marketplace
registerPublisher(program)
registerKeygen(program)
registerInit(program)
registerPack(program)
registerRegistry(program)
registerPackage(program)

// Escape hatch
registerApi(program)

// Self-update
registerUpdate(program)

async function main(): Promise<void> {
  try {
    await program.parseAsync()
  } catch (error: unknown) {
    if (error instanceof ApiError || error instanceof Error) {
      console.error(`Error: ${error.message}`)
    } else {
      console.error(error)
    }
    process.exitCode = 1
  }
  // Best-effort "new version available" notice; never affects the command's outcome.
  await notifyOnExit(process.argv)
}

void main()
